<template>
  <BaseDialog
    max-width="700"
    :value="dialogState"
    persistent
    @click:outside="close()"
  >
    <template #modal>
      <BaseCosmoCard>
        <template #title>
          <div class="modal_header">
            <BaseTitle v-text="$t('utils.use')" />
            <BaseButtonIcon
              class="close_icon"
              icon="$mdiClose"
              @click="close()"
            />
          </div>
        </template>
        <div v-if="docxTemplate && docxTemplate.isUsed" class="modal_content">
          <div class="usage">
            <div class="usage_title" v-text="$t('utils.workflow')" />
            <ul>
              <li
                v-for="(usage, index) in docxTemplate.usage.workflow"
                :key="index"
              >
                <router-link
                  :to="{
                    name: 'workflowDetail',
                    params: {
                      organizationId: organizationId,
                      workflowId: `${usage.id}`,
                    },
                  }"
                  tag="a"
                  class="usage_item"
                  v-text="usage.name"
                />
              </li>
            </ul>
          </div>
        </div>
        <div class="modal_footer">
          <BaseButton color="grey" type="secondary" @click="close()">
            {{ $t("navigation.close") }}
          </BaseButton>
        </div>
      </BaseCosmoCard>
    </template>
  </BaseDialog>
</template>

<script>
export default {
  name: "DocxTemplateUsageDialog",
  props: {
    dialogState: {
      type: Boolean,
    },
    docxTemplate: {
      type: Object,
      default: () => null,
    },
    organizationId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.modal_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  padding-top: 8px;
  flex-wrap: wrap;
  .modal_title {
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: #353542;
  }
  .close_icon {
    margin-left: auto;
  }
}
.modal_content {
  padding-top: 24px;
  .usage {
    font-family: "Inter";
    margin-bottom: 6px;
    .usage_title {
      color: #353542;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
      margin-bottom: 4px;
    }
    .usage_item {
      font-size: 14px;
      text-decoration: underline;
      cursor: pointer;
      line-height: 20px;
      color: #2196f3;
    }
  }
  .modal_text {
    color: #353542;
    text-align: center;
    font-family: "Inter";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 16px;
    &:last-child {
      margin: 0;
    }
  }
}
.modal_footer {
  display: flex;
  justify-content: flex-end;
  align-content: center;
  padding: 8px 0;
  & > * {
    margin-left: 16px;
  }
}
</style>
